(function () {
  const $shareList = document.querySelector('[data-share-list]');
  if (navigator.share) {
    const $shareBtnMobile = $shareList.querySelector('[data-mobile-share]');
    $shareBtnMobile.onclick = async function () {
      await navigator.share({
        title: document.title,
        text: document.title,
        url: location.href,
      });
    };
  }

  const $shareBtnDesktop = $shareList.querySelector('[data-copy-to-clipboard]');
  $shareBtnDesktop.addEventListener('click', function () {
    navigator.clipboard.writeText(location.href).then(() => {
      const $successMessage = $shareBtnDesktop.nextElementSibling;
      $successMessage.innerText =
        window.accessibilityStrings.shareSuccess || 'Link copied to clipboard';
      $successMessage.classList.add('visible');
      setTimeout(() => {
        $successMessage.classList.remove('visible');
      }, 2000);
    });
  });
})();
